import { createSlice } from "@reduxjs/toolkit";
import { fetchWaivedOffAppointments, waiveOffAppointment } from "../WaiverOff/appointmentsThunk";

const initialState = {
  fetchWaivedSuccess: null,
  fetchWaivedError: null,
  waiveOffSuccess: null,
  waiveOffError: null,
};

const appointmentsSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    resetFetchWaived(state) {
      state.fetchWaivedSuccess = null;
      state.fetchWaivedError = null;
    },
    resetWaiveOff(state) {
      state.waiveOffSuccess = null;
      state.waiveOffError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWaivedOffAppointments.fulfilled, (state, action) => {
        state.fetchWaivedSuccess = action.payload;
        state.fetchWaivedError = null;
      })
      .addCase(fetchWaivedOffAppointments.rejected, (state, action) => {
        state.fetchWaivedError = action.payload;
        state.fetchWaivedSuccess = null;
      })
      .addCase(waiveOffAppointment.fulfilled, (state, action) => {
        state.waiveOffSuccess = action.payload;
        state.waiveOffError = null;
      })
      .addCase(waiveOffAppointment.rejected, (state, action) => {
        state.waiveOffError = action.payload;
        state.waiveOffSuccess = null;
      });
  },
});

export const { resetFetchWaived, resetWaiveOff } = appointmentsSlice.actions;

export default appointmentsSlice.reducer;
